import {
  GET_VIDEOS,
  CLEAR_ERRORS,
  GET_RESOURCE,
  GET_COMMENTS,
  SET_FILTER,
  ADD_COMMENT,
  ADD_REPLY,
  LOADING,
  CLEAR_RESOURCE,
  CLEAR_LATEST,
  ADD_MORE,
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case GET_VIDEOS:
      return {
        ...state,

        videos: action.payload,
      };
    case LOADING:
      return { ...state, loading: !state.loading };
    case GET_RESOURCE:
      return {
        ...state,
        resource: action.payload,
      };
    case CLEAR_RESOURCE:
      return { ...state, resource: null, comments: null, videos: null };
    case ADD_COMMENT:
      return { ...state, comments: action.payload };
    case ADD_REPLY:
      return {
        ...state,
        comments: null,
      };
    case ADD_MORE:
      return {
        ...state,
        videos: [...state.videos, ...action.payload],
      };
    case SET_FILTER:
      return { ...state, query: action.payload };
    case CLEAR_ERRORS:
      return { ...state, errors: null };
    case GET_COMMENTS:
      return { ...state, comments: action.payload };
    case CLEAR_LATEST:
      return { ...state, videos: null };
    default:
      return state;
  }
};
